export default function analyticsTracker(platform, eventName, eventParam, eventValues) {
  if (process.env.REACT_APP_SC_ENV === 'production') {
    const params = {};
    switch (platform) {
      case 'fb':
        params[eventParam] = eventValues;
        if (window.FB) {
          window.FB.AppEvents.logEvent(eventName, null, params);
        }
        break;
      case 'gtag':
        // window.ga('send', 'event', [eventCategory], [eventAction], [eventLabel], [eventValue], [fieldsObject]);
        if (window.ga) {
          window.ga('send', 'event', {
            eventCategory: eventName,
            eventAction: eventName,
            eventLabel: eventValues,
          });
        }

        // window.gtag('event', eventParam, {
        //   event_category: eventName,
        //   event_label: eventValues,
        // });
        break;
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js